import { render, staticRenderFns } from "./FeedbackMessage.vue?vue&type=template&id=c99b6714&scoped=true&"
import script from "./FeedbackMessage.vue?vue&type=script&lang=js&"
export * from "./FeedbackMessage.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackMessage.vue?vue&type=style&index=0&id=c99b6714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99b6714",
  null
  
)

export default component.exports